import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10' },
  { text: '', value: 'expand_action', width: '10' },
  { text: 'Trace ID', value: 'trace_id' },
  { text: 'Type', value: 'process_name' },
  { text: 'Bill Number', value: 'response_raw.data.bill_number', width: '150' },
  { text: 'Request Time', value: 'inserted' },
  { text: 'Brief Activity', value: 'custom_status', width: '400', align: 'center' },
]);

export const search = {
  process_name: '',
  trace_id: '',
  merchant_id: '',
  status: '',
  rrn: '',
  bill_num: '',
  request_date: [],
};
